/* NAD Hair — Trusted Carousel
   - Scroll-snap carousel with arrow controls
   - Progressive enhancement (touch/trackpad scroll works without arrows)
*/

(function () {
  function init(root) {
    const track = root.querySelector(".nhtr__track");
    if (!track) return;

    const btnPrev = root.querySelector("[data-nhtr-prev]");
    const btnNext = root.querySelector("[data-nhtr-next]");
    if (!btnPrev || !btnNext) return;

    function getStep() {
      const slide = track.querySelector(".nhtr__slide");
      if (!slide) return Math.max(320, track.clientWidth * 0.9);

      const rect = slide.getBoundingClientRect();
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;

      return rect.width + gap;
    }

    function updateButtons() {
      const maxScrollLeft = track.scrollWidth - track.clientWidth - 2;
      const x = track.scrollLeft;

      btnPrev.disabled = x <= 2;
      btnNext.disabled = x >= maxScrollLeft;
    }

    btnPrev.addEventListener("click", function () {
      track.scrollBy({ left: -getStep(), behavior: "smooth" });
    });

    btnNext.addEventListener("click", function () {
      track.scrollBy({ left: getStep(), behavior: "smooth" });
    });

    track.addEventListener("scroll", function () {
      window.requestAnimationFrame(updateButtons);
    });

    window.addEventListener("resize", function () {
      window.requestAnimationFrame(updateButtons);
    });

    updateButtons();
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-nhtr]").forEach(init);
  });
})();
